<div
  [ngClass]="{
    'd-flex align-items-start align-items-sm-center flex-column flex-sm-row flex-wrap':
      horizontalSingleSelection
  }"
>
  <ng-container
    *ngIf="editable || (!editable && !isViewAsText); else viewAsTextRef"
  >
    <ng-container *ngFor="let item of items; let isFirst = first; let index = index">
      <div
        class="organization__radio-item mb-3"
        [ngClass]="{
          'ml-sm-4': horizontalSingleSelection && !isFirst
        }"
      >
        <input
          appRequireLogin
          [value]="item.codeId"
          class="organization__radio"
          [id]="item.codeId"
          [name]="controlName"
          [checked]="item.codeId === items[currentIndex].codeId"
          type="radio"
          [class.disabled-input]="!editable"
          (change)="onRadioChange($event, item, index)"
        />
        <div class="d-flex align-items-center">
          <label
            class="radio-info"
            [for]="item.codeId"
            [class.disabled-action]="!editable"
          >
            <span class="radio-text font-size-sm">
              {{ item.value }}
            </span>
          </label>

          <i
            *ngIf="showHelpText && item.helpTextId"
            class="fas fa-info-circle pointer-cursor organization__radio-tooltip"
            appTooltip
            triggers="click"
            [ngbTooltip]="item.helpTextId | translate"
            placement="right"
            (click)="$event.preventDefault()"
          ></i>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #viewAsTextRef>
  {{ items[currentIndex]?.value }}
</ng-template>
